import React, { useState } from "react";
import { AxiosHelper } from "../helper/apiClient";
import ReCAPTCHA from "react-google-recaptcha";

const Contact = () => {
  const [formData, setFormData] = useState<any>({
    name: "",
    email: "",
    subject: "",
    message: "",
    captcha: false,
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formStatus, setFormStatus] = useState(false);

  const inputHandler = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsSubmitted(true);

    if (formData.captcha === true) {
      try {
        const res = await AxiosHelper.post(
          "https://uniquicksolutions.com/api/api/sendMail",
          formData
        );
        if (res) {
          setFormStatus(true);
          setTimeout(() => {
            setIsSubmitted(false);
            setFormData({
              name: "",
              email: "",
              subject: "",
              message: "",
              captcha: false,
            });
          }, 5000);
        } else {
          setFormStatus(false);
        }
      } catch (error) {
        console.log(error);
        setFormStatus(false);
      }
    }
  };

  const handleCaptcha = (props: any) => {
    setFormData({ ...formData, captcha: true });
    setIsSubmitted(false);
  };

  const captchaError = () => {
    setFormData({ ...formData, captcha: false });
    setIsSubmitted(false);
  };

  return (
    <>
      <section id="contact" className="contact">
        <div className="container">
          <div className="section-title">
            <span>Contact</span>
            <h2>Contact</h2>
          </div>

          <div className=" mt-5 mt-lg-0 d-flex align-items-stretch">
            <form
              onSubmit={handleSubmit}
              //   action="sendMail.php"
              //   method="post"
              //   role="form"
              className="php-email-form"
              name="contactForm"
              id="contactForm"
              // enctype="multipart/form-data"
            >
              <div className="row">
                <div className="form-group col-md-6 ">
                  <label htmlFor="name" className="label">
                    Your Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    id="name"
                    onChange={(e) => inputHandler(e)}
                    value={formData?.name}
                    required
                  />
                </div>
                <div className="form-group col-md-6 mt-3 mt-md-0">
                  <label htmlFor="name" className="label">
                    Your Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    id="email"
                    onChange={(e) => inputHandler(e)}
                    value={formData?.email}
                    required
                  />
                </div>
              </div>
              <div className="form-group mt-3">
                <label htmlFor="name" className="label">
                  Subject
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="subject"
                  id="subject"
                  onChange={(e) => inputHandler(e)}
                  value={formData?.subject}
                  required
                />
              </div>
              <div className="form-group mt-3">
                <label htmlFor="name" className="label">
                  Message
                </label>
                <textarea
                  className="form-control"
                  name="message"
                  rows={10}
                  onChange={(e) => inputHandler(e)}
                  value={formData?.message}
                  required
                ></textarea>
              </div>
              <div className="row">
                <div className="form-group col-6">
                  <label className="label">Enter Captcha</label>
                  {/* <input
                    type="text"
                    className="form-control"
                    name="captcha"
                    onChange={(e) => inputHandler(e)}
                    value={formData?.captcha}
                    required
                  /> */}
                </div>
                <ReCAPTCHA
                  sitekey="6Le_FHsjAAAAAAaLSavm_i78IRCn3XKIfP5D7Frv"
                  onChange={handleCaptcha}
                  onErrored={captchaError}
                  onExpired={captchaError}
                />
              </div>
              <div className="my-3">
                <div className="loading">Loading</div>
                {isSubmitted && formData.captcha && formStatus && (
                  <div className="sent-message1">
                    Your message has been sent. Thank you!
                  </div>
                )}
                {isSubmitted && !formData.captcha ? (
                  <div className="error-message1">Invalid Captcha</div>
                ) : (
                  isSubmitted &&
                  formData.captcha &&
                  !formStatus && (
                    <div className="error-message1">Server Error</div>
                  )
                )}
              </div>
              <div className="text-center">
                <button type="submit" name="send" value="Send" id="submit">
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
